export default __webpack_public_path__ + "static/media/Quiosques.3449e7d8.png";